import { generateRegressionData } from './regressionData';

export function findOptimalSor(
  swArr: (number | null)[],
  kroArr: (number | null)[],
  swir: number,
  selectedIndices: number[]
): { bestSor: number; bestR2: number } | null {
  
  let maxPossibleSor = 1 - swir; 
  
  const selectedSw = selectedIndices
    .map(i => swArr[i])
    .filter(val => val != null) as number[];

  if (selectedSw.length === 0) return null;

  for (const sw of selectedSw) {
    const limit = 1 - sw;
    if (limit < maxPossibleSor) maxPossibleSor = limit;
  }

  maxPossibleSor -= 0.001; 

  if (maxPossibleSor <= 0) return null;

  let bestSor = 0;
  let bestR2 = -1;

  for (let testSor = 0; testSor <= maxPossibleSor; testSor += 0.001) {
    const data = generateRegressionData(swArr, kroArr, swir, testSor);
    const pointsToTest = data.filter(p => selectedIndices.includes(p.key));

    if (pointsToTest.length < 2) continue;

    try {
        let N = 0, sumX = 0, sumY = 0, sumX2 = 0, sumY2 = 0, sumXY = 0;
        
        for (const p of pointsToTest) {
            const x = Math.log(p.so);
            const y = Math.log(p.kro);
            N++; sumX += x; sumY += y; sumX2 += x*x; sumY2 += y*y; sumXY += x*y;
        }
        
        const denominator = N * sumX2 - sumX * sumX;
        if (Math.abs(denominator) > 1e-9) {
            const r2Num = Math.pow(N * sumXY - sumX * sumY, 2);
            const r2Den = denominator * (N * sumY2 - sumY * sumY);
            const r2 = r2Den === 0 ? 0 : r2Num / r2Den;

            if (r2 > bestR2) {
                bestR2 = r2;
                bestSor = testSor;
            }
        }
    } catch (e) {
        continue;
    }
  }

  return bestR2 !== -1 ? { bestSor, bestR2 } : null;
}